// extracted by mini-css-extract-plugin
export var progressBar = "_nr-0";
export var progressBarInner = "_nr-1";